// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/ee8fa8f3e18d97d7d9ad.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"a181b1960d8f5c586688","168":"b851c40e3c681da3a99c","169":"06016d7b65bf7f6c2062"}[chunkId] + ".chunk.js";
};